<div style="overflow-x: scroll;">
    <table class="table table-bordered table-hover">
        <thead>
            <tr>
                <!-- <th scope="col">S.No</th> -->
                <th scope="col">Title</th>
                <th scope="col" class="text-center">View</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of data; let i=index;" class="text-left">
                <!-- <th scope="row">{{i+1}}</th> -->
                <td [ngClass]="item.path == '' ? 'fw-bold' : ''">{{item.title}}</td>
                <td class="text-center"><a href="{{item.path}}" target="_blank" *ngIf="item.path != ''"><i
                            class="fas fa-eye"></i></a></td>
            </tr>
        </tbody>
    </table>
</div>